// extracted by mini-css-extract-plugin
export default {"blender_bottle_item":"ky","blender_bottle_img":"ly","blender_bottle_info":"my","blender_bottle_title":"ny","blender_bottle_bold":"oy","blender_bottle_usual":"py","blender_bottle_item_mob":"qy","addbutton":"ry","blender_bottle_title_mob":"sy","blender_bottle_bold_mob":"ty","blender_bottle_usual_mob":"uy","bolder":"vy","bottom_margin_4":"wy","bottom_margin_16":"xy"};
    if(module.hot) {
      // 1711717533304
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  